var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#9D9D9D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M76.822,61.582c0,3.142-2.548,5.688-5.688,5.688 H28.086c-3.142,0-5.688-2.547-5.688-5.688V24.399c0-3.142,2.546-5.688,5.688-5.688h43.048c3.14,0,5.688,2.546,5.688,5.688V61.582z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#9D9D9D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M74.052,77.932c0,1.904-1.229,3.447-2.741,3.447 H27.91c-1.514,0-2.742-1.543-2.742-3.447V65.786c0-1.905,1.228-3.446,2.742-3.446h43.401c1.513,0,2.741,1.543,2.741,3.446V77.932 L74.052,77.932z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#9D9D9D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M25.22,68.97c0,1.516-1.4,2.742-3.127,2.742 h-5.83c-1.728,0-3.127-1.227-3.127-2.742L7.942,39.266c-1.485-6.809,1.638-9.298,4.665-9.298h9.486c1.727,0,3.127,1.227,3.127,2.742 L25.22,68.97L25.22,68.97z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#9D9D9D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M74.002,68.959c0,1.516,1.399,2.742,3.127,2.742 h5.831c1.729,0,3.127-1.227,3.127-2.742l5.194-29.704c1.484-6.809-1.639-9.298-4.664-9.298h-9.488c-1.728,0-3.127,1.228-3.127,2.742 V68.959z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableSeat);
export default __webpack_public_path__ + "static/media/available_seat.066cc19d8901f6e3c1e7da680f6f46a7.svg";
export { ForwardRef as ReactComponent };